<template>
  <div>
    <h6 style="font-size:16px !important;"
        v-if="singleFlag">今日{{singleName}}截止目前累计收入：{{singleTotal}}元</h6>
    <h6 style="font-size:16px !important;"
        v-else>今日截止目前累计收入：{{total}}元</h6>
    <div style="height:10px;"></div>
    <v-button-group>
      <v-button @click="initData">全部</v-button>
      <v-button v-for="(item,index) in appArr"
                @click="choiceApp(item)"
                :key="index">{{item}}</v-button>
    </v-button-group>
    <br>
    <div style="height:10px;"></div>
    <span>时间</span>
    <v-date-picker range
                   style="width:300px;"
                   v-model="rangeDate"
                   clearable
                   show-time
                   @confirm="confirm"
                   @change="rangeChange"></v-date-picker>
    <span>时间单位</span>
    <v-select style="width: 200px;"
              :data="selectOptions"
              :allowClear="false"
              v-model="selectValue"></v-select>
    <v-button type="primary"
              @click="initData('search')">查询</v-button>
    <v-button type="primary"
              @click="exportExl">导出</v-button>
    <div style="height:30px;"></div>
    <v-chart id="chart"
             ref="chart"
             :options="option" />
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title.js'
import axios from 'axios'
export default {
  components: {
    'v-chart': ECharts
  },
  data () {
    return {
      singleTotal: '',
      singleFlag: false,
      singleName: '',
      total: '',
      rangeDate: ['', ''],
      timeArr: [],
      appArr: [],
      appDataArr: [],
      selectOptions: [{
        value: 'H',
        label: '小时'
      }, {
        value: 'Y',
        label: '年'
      }, {
        value: 'M',
        label: '月'
      }, {
        value: 'D',
        label: '天'
      }, {
        value: 'I',
        label: '分'
      }],
      selectValue: 'H',
      option: {
        title: {
          text: '收入概况'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: []
      }
    }
  },
  methods: {
    exportExl () {
      let startTime
      let endTime
      if (this.rangeDate[0] !== '') {
        startTime = parseInt(new Date(this.rangeDate[0]).getTime() / 1000)
        endTime = parseInt(new Date(this.rangeDate[1]).getTime() / 1000)
      } else {
        startTime = this.getDayTime() / 1000
        endTime = parseInt(new Date().getTime() / 1000)
      }
      let url = 'dev/export_income_statistics'
      url = url + '/' + startTime + '/' + endTime + '?interval=' + this.selectValue
      axios.get(url)
        .then(res => {
          if (res.data.download_link) {
            window.location.href = res.data.download_link
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    choiceApp (name) {
      // 获得单个应用的收入
      this.singleTotal = this.appDataArr[name].all_total
      this.singleFlag = true
      this.singleName = name
      this.option.legend.data = Object.keys(this.appDataArr[name].sub_channel)
      let yData = []
      this.option.legend.data.forEach(item => {
        let obj = {}
        obj.name = item
        obj.type = 'line'
        obj.data = this.appDataArr[name].sub_channel[item]
        yData.push(obj)
      })
      this.option.title.text = name + '收入概况'
      this.option.series = yData
      this.$refs.chart.refresh()
      // this.$refs.chart.setOption(this.option, true)
    },
    confirm () {
      console.log('confirm')
    },
    change (time) {
      console.log('change:', time)
    },
    rangeChange (startTime, endTime) {
      console.log('change:', startTime, endTime)
    },
    initData (type) {
      this.singleFlag = false
      if (type) {
        if (this.rangeDate[0] === '' && this.selectValue !== 'H') {
          this.$message['error']('请选择时间')
          return
        }
      }
      let startTime
      let endTime
      // 判断是否有查询条件
      if (this.rangeDate[0] !== '') {
        startTime = parseInt(new Date(this.rangeDate[0]).getTime() / 1000)
        endTime = parseInt(new Date(this.rangeDate[1]).getTime() / 1000)
      } else {
        startTime = this.getDayTime() / 1000
        endTime = parseInt(new Date().getTime() / 1000)
      }
      this.option.title.text = '全部App收入概况'
      let url = 'dev/income_statistics'
      url = url + '/' + startTime + '/' + endTime + '?interval=' + this.selectValue
      axios.get(url)
        .then(res => {
          if (res.data.code === 200) {
            if (!type) {
              this.total = res.data.result.total
            }
            this.timeArr = res.data.result.time_frame
            this.appArr = Object.keys(res.data.result.statistical_data)
            let yData = []
            this.appArr.forEach(element => {
              let obj = {}
              obj.name = element
              obj.type = 'line'
              obj.data = res.data.result.statistical_data[element].total
              yData.push(obj)
            })
            this.option.xAxis.data = this.timeArr
            this.option.series = yData
            this.appDataArr = res.data.result.statistical_data
            this.option.legend.data = this.appArr
            this.$refs.chart.refresh()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getDayTime () {
      let date = new Date()
      let times = date.getTime()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      let milli = date.getMilliseconds()
      let dayTime = times - hour * 3600 * 1000 - minute * 60 * 1000 - second * 1000 - milli
      return dayTime
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
#chart {
  width: calc(100vw - 320px);
  height: 500px;
}
</style>
<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/pages/overview/overview.vue